<p-dialog [modal]="true" [(visible)]="visible">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Revise quantity for {{ forecast.planningParameter.name }} on {{ forecast.year }}-{{ forecast.month | number: '2.0' }}
        </span>
    </ng-template>

    @if (revisions && revisions.getForecastRevisions().length > 0) {
        <div class="grid">
            <div class="col-12">
                <h4>Existing revisions</h4>
            </div>
        </div>

        <div class="grid">
            <div class="col-12">
                <p-table [value]="revisions.getForecastRevisions()">
                    <ng-template #header>
                        <tr>
                            <th>User</th>
                            <th>Quantity</th>
                            <th>Created</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-revision>
                        <tr>
                            <td>{{ revision.user }}</td>
                            <td>{{ revision.quantity }}</td>
                            <td>{{ revision.created | date: 'dd.MM.yyyy HH:mm' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    }

    <div class="row mt-5">
        <div class="col-6">
            <p-fluid>
                <div class="field">
                    <label for="revisedQuantity">Revised quantity</label>
                    <p-inputNumber
                        [(ngModel)]="revisedQuantity"
                        [showButtons]="true"
                        buttonLayout="horizontal"
                        inputId="revisedQuantity"
                        [step]="1"
                        mode="decimal"
                    >
                        <ng-template #incrementbuttonicon>
                            <span class="pi pi-plus"></span>
                        </ng-template>
                        <ng-template #decrementbuttonicon>
                            <span class="pi pi-minus"></span>
                        </ng-template>
                    </p-inputNumber>
                </div>
            </p-fluid>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()" />
        <p-button label="Save" [outlined]="true" severity="success" (click)="reviseQuantity()" />
    </ng-template>
</p-dialog>
